<template>
  <div>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="this.label" :dialog="dialogConfirm" @confirm="deleteValue(entity, values, label, false)" @cancel="closeDialogDelete"></p-confirm>
      <v-layout>
        <v-flex xs12 class="pa-0">
          <!-- // type serve para quando vem o selecte_editable que tem que mandar o type para saber quais registros buscar -->
          <p-select :id="id" :entity="entity" ref="PSelect" :onlyThisItems="onlyThisItems" :companyId="companyId" :type="entity === 'select_editable' ? values['type'] : null" :loading="load" :disabled="disable" :label="label" @change="changeItem" @blur="blurSelect"  :value="value" @input="(val)=>{$emit('input', val)}" :clearable="clearable" :itemsProps="itemsProps" :selectedItem="selectedItem" :rules="rules" showAddItem showEditItem @clickAdd="modalCreate()" @clickEdit="editSelectItem" :placeholder="placeholder" :multiple="multiple" :item_text="item_text" :item_value="item_value">
          </p-select>
        </v-flex>
        <v-flex v-if="showActions && value && !multiple" style="min-width: 45px" class="pa-0">
          <v-tooltip top>
            <v-btn :id="id+'_edit'" slot="activator" small flat color="grey lighten-4" fab class="mx-0" @click="editSelectItem()">
              <v-icon color="orange">edit</v-icon>
            </v-btn>
            <span>Editar</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title primary-title>
          <v-layout align-center justify-space-between>
            <span class="headline">{{ this.formTitle }}</span>
            <v-btn :id="id+'_delete'" @click="deleteSelectItem()" outline color="pink">Excluir</v-btn>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @keyup.native.esc="close()" @keyup.native.ctrl.enter="saveCreateItem">
            <slot></slot>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="saveCreateItem()">Salvar</v-btn>
          <v-btn flat @click="close()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
  /* Overflow: visible para que o vue-swatches fique visível ao ser aberto no modal. */
  .v-dialog--persistent {
    overflow-y: visible !important;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
</style>

<script>
  /* eslint-disable eqeqeq */
  import crud from './../../mixin/crud'
  import PConfirm from './../shared/PConfirm'
  import PSelect from './../shared/PSelect'

  export default {
    name: 'selectModalEditable',
    mixins: [crud],
    components: {PConfirm, PSelect},
    props: {
      id: {
        default: 'id_field_modal'
      },
      entity: {
        default: 'field_entity'
      },
      label: {},
      value: {
        default: null
      },
      // selectedItem representa o item selecionado para acrescentar quando ele não estiver na busca
      selectedItem: {
        default: null
      },
      // onlyThisItems usado para trazer os ids e buscar apenas aqueles ids
      onlyThisItems: {
        default: null
      },
      itemsProps: {
        default: null
      },
      placeholder: {
        default: ''
      },
      companyId: {
        default: ''
      },
      item_text: {
        default: 'id_text'
      },
      item_value: {
        default: 'id'
      },
      values: {},
      disable: false,
      load: false,
      rules: {},
      showActions: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        dialog: false,
        // editedItem: null,
        // defaultItem: null
        defaultValue: null
      }
    },
    watch: {
      // Usado o value no watch, para que o editedItem receba o valor quando ele for alterado
      // value: function (val) {
      //   if (val && Array.isArray(this.itemsProps)) {
      //     // Se tiver valores já definidos pesquisa entre eles, caso não tenha so pega o valor do item selecionado
      //     this.editedItem = this.itemsProps.find((value) => { return value[this.item_value] === val }) || JSON.parse(JSON.stringify(this.selectedItem))
      //   } else {
      //     this.editedItem = this.selectedItem ? JSON.parse(JSON.stringify(this.selectedItem)) : JSON.parse(value)
      //   }
      // }
    },
    mounted () {
      this.defaultValue = JSON.parse(JSON.stringify(this.value))
      // Não está mais sendo usado o editedItem porisso foi tudo comentado
      // Estrutura para jogar os valores defaults no editedItem e defaultItem, pois o id e o id_text podem ser outros
      // let value = `{"${this.item_value}": null, "${this.item_text}": ""}`
      // this.editedItem = JSON.parse(value)
      // this.defaultItem = JSON.parse(value)
      // Coloca o valor no editedItem a primeira vez, depois o valor é colocado no watch
      // if (Array.isArray(this.itemsProps)) {
      //   this.editedItem = this.itemsProps.find((val) => { return val[this.item_value] === this.value }) || this.selectedItem
      // } else {
      //   this.editedItem = this.selectedItem ? JSON.parse(JSON.stringify(this.selectedItem)) : JSON.parse(value)
      // }
    },
    methods: {
      changeItem (id, item) {
        if (item) {
          // coloca o emit no input tbm, pois não estava alterando o v-model quando criava um regsitro
          this.$emit('input', id)
          this.$emit('change', id, item)
          // this.editedItem = JSON.parse(JSON.stringify(item))
        } else {
          this.$emit('input', null)
          this.$emit('change', null, {})
          // this.editedItem = {id: null, id_text: ''}
        }
      },
      blurSelect () {
        if (this.values && this.values[this.item_value] > 0) {
          this.$emit('blur', this.values[this.item_value], this.values)
        } else {
          this.$emit('blur', null, {})
        }
        // let item = this.items.find(val => val[this.item_value] === id)
      },
      // Usado em momentos que é necessário trazer os valores antes pelo componente mãe.
      getValues () {
        this.$refs.PSelect.getValues()
      },
      modalCreate () {
        // Cria um campo value que recebe o id_text pois nos filtros da tarefa o id é o value que está com o nome
        // Ocorre na categoria e no status
        // monta o defaultValue de acordo com o id e o id_text
        let defaultValue = JSON.parse(`{"${this.item_value}": "", "${this.item_text}": ""}`)
        // this.values = {}
        // quando o item_value não é id (exemplo: status ou categoria) adiciona o id, pois o id naõ estava sendo zerado não dando pra adicionar novos itens
        if (this.item_value != 'id') Object.assign(defaultValue, {id: null})
        // faz o values receber para o values ser zerado
        Object.assign(this.values, defaultValue)
        // this.values = {}
        // this.values[this.item_text] = ''
        this.dialog = true
        this.view = 2
        // foca o campo que posusi o id=modalfocus quando abre o modal
        if (document.getElementById('modalfocus')) {
          this.$nextTick(() => document.getElementById('modalfocus').focus())
        }
      },
      saveCreateItem () {
        // remover as aspas duplas pois quando tentava salvar no banco dava problema
        this.values[this.item_text] = this.values[this.item_text].replaceAll('"', '')
        if (this.view === 2) {
          if (this.values[this.item_text] === '') {
            this.$store.commit('snackbar/change_values', {text: 'Favor informar o campo "' + this.label + '" para incluir!', color: 'warning', dialog: true})
          } else if (Array.isArray(this.itemsProps) && this.itemsProps.filter(a => a[this.item_text] === this.values[this.item_text]).length > 0) {
            this.$store.commit('snackbar/change_values', {text: 'O item "' + this.values[this.item_text] + '" já existe na lista!', color: 'warning', dialog: true})
          } else {
            this.$http.post(`api/${this.entity}`, this.values).then(
              (res) => {
                let resBody = res.body
                // Cria um campo value que recebe o id_text pois nos filtros da tarefa o id é o value que está com o nome
                // Ocorre na categoria e no status
                if (this.entity === 'task_status' || this.entity === 'task_category') resBody['value'] = resBody['id_text']
                if (Array.isArray(this.itemsProps)) this.itemsProps.push(resBody)
                // this.editedItem = res.body
                // Adiciona o item o item
                if (this.multiple) {
                  let itemsIds = JSON.parse(JSON.stringify(this.value))
                  itemsIds.push(resBody[this.item_value])
                  this.$refs.PSelect.items.push(resBody)
                  let items = []
                  itemsIds.forEach(id => {
                    items.push(this.$refs.PSelect.items.find(item => item[this.item_value] === id))
                  })
                  this.changeItem(itemsIds, items)
                } else {
                  this.changeItem(resBody[this.item_value], resBody)
                }
                this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.label + ' incluído com sucesso!', color: 'success', dialog: true})
              }, err => {
                console.log(err)
                if (err.body.message === 'nameExists') {
                  this.$store.commit('snackbar/change_values', {text: 'Não foi possivel incluir o registro de ' + this.label + ', nome já existe!', color: 'warning', dialog: true})
                } else {
                  this.$store.commit('snackbar/change_values', {text: 'Não foi possivel incluir o registro de ' + this.label + ', reporte o erro!', color: 'error', dialog: true})
                }
              })
            this.close()
          }
        } else if (this.view === 3) {
          if (this.values[this.item_text] !== '') {
            // caso seja status e os registros sejam os 3 primeiros, náo permite pois são os padroes
            if ((this.entity === 'task_status') && (this.values[this.item_text] == 'Finalizada' || (this.values.identifier && this.values.identifier < 3))) {
              this.$store.commit('snackbar/change_values', {text: 'Você não pode alterar um item padrão', color: 'warning', dialog: true})
              return false
            }
            // usa this.values['id'] pois até nos status precisa ser o id
            this.$http.put(`api/${this.entity}/` + this.values['id'],
              this.values).then(
              (res) => {
                let resBody = res.body
                // Ocorre na categoria e no status
                if (this.entity === 'task_status' || this.entity === 'task_category') {
                  if (resBody['reloadBoards']) {
                    let type = this.entity === 'task_status' ? 'taskStatus' : (this.entity === 'task_category' ? 'taskCategories' : '')
                    let reloadBoards = JSON.parse(JSON.stringify(resBody['reloadBoards']))
                    // Apos armazenar o reloadBoards, tira ele do resBody pois ele so serve para mandar o socket
                    delete resBody['reloadBoards']
                    reloadBoards.forEach(item => {
                      console.log('reloadBoards', item)
                      // Atualiza todos os boards iguais
                      this.$socket.emit('generalEvent', {
                        data: {values: item, type: type},
                        notBroadcast: true,
                        responseEvent: 'socketReloadBoards',
                        room: `selectedBoard${item['id']}`
                      })
                    })
                  }
                  // Cria um campo value que recebe o id_text pois nos filtros da tarefa o id é o value que está com o nome
                  resBody['value'] = resBody['id_text']
                }
                // usa ['id'] pois até nos status precisa ser o id
                if (Array.isArray(this.itemsProps)) Object.assign(this.itemsProps.find((val) => { return val['id'] === resBody['id'] }) || {}, resBody)
                // atualiza o item dentro do pselect
                let item = this.$refs.PSelect.items.find((val) => { return val['id'] === resBody['id'] }) || {}
                // Armazena o valor antigo para verificar
                let beforeItem = JSON.parse(JSON.stringify(item))
                Object.assign(item, resBody)
                // se o nome do status ou categoria tiver sido alterado muda o item pois no filtro de tarefas está salvando pelo id_text portanto se o usuário muda a descrição deve também mudar no campo da tarefa
                if (beforeItem['id_text'] !== item['id_text'] && (this.entity === 'task_status' || this.entity === 'task_category')) {
                  if (this.multiple) {
                    let itemsIds = JSON.parse(JSON.stringify(this.value))
                    // insere o registro atual
                    itemsIds.push(resBody[this.item_value])
                    // exclui o registro antigo
                    itemsIds.splice(itemsIds.indexOf(beforeItem[this.item_value]), 1)
                    let items = []
                    itemsIds.forEach(id => {
                      items.push(this.$refs.PSelect.items.find(item => item[this.item_value] === id))
                    })
                    this.changeItem(itemsIds, items)
                  } else {
                    // Quando não é multiplo, so é permitido editar o registro selecionado, portanto já edita
                    this.changeItem(resBody[this.item_value], resBody)
                  }
                }
                this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.label + ' editado com sucesso!', color: 'success', dialog: true})
                // recarrega as tarefas do usuário para que pelo menos no dele as tarefas estejam atualizadas
                this.$socket.emit('generalEvent', {
                  data: {},
                  notBroadcast: true,
                  responseEvent: 'reloadTasksAll',
                  room: `tasks${this.$auth.user().id}`
                })
              }, err => {
                console.log(err)
                this.$store.commit('snackbar/change_values', {text: 'Não foi possivel editar o registro de ' + this.label + ', nome já existe!', color: 'error', dialog: true})
              })
            this.close()
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Favor informar o campo "' + this.label + '" para salvar!', color: 'warning', dialog: true})
          }
        }
      },
      editSelectItem (item = this.selectedItem) {
        // caso seja status e os registros sejam os 3 primeiros, náo permite pois são os padroes
        // usa !item pois se o status não tiver, ele é não inciado, sendo um status padrão
        if ((this.entity === 'task_status') && (!item || item[this.item_text] == 'Finalizada' || (item['identifier'] && item['identifier'] < 3))) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possível alterar um item padrão.', color: 'warning', dialog: true})
          return false
        }
        // this.editedItem = JSON.parse(JSON.stringify(item))
        Object.assign(this.values, JSON.parse(JSON.stringify(item)))
        this.editItem(item)

        // foca o campo que posusi o id=modalfocus quando abre o modal
        if (document.getElementById('modalfocus')) {
          this.$nextTick(() => document.getElementById('modalfocus').focus())
        }
      },
      deleteSelectItem () {
        if ((this.entity === 'task_status') && (this.values[this.item_text] == 'Finalizada' || (this.values.identifier && this.values.identifier < 3))) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possível deletar um item padrão.', color: 'warning', dialog: true})
          return false
        }
        this.dialogDelete(this.values)
        this.close()
      },
      close () {
        this.view = 1
        this.dialog = false
      },
      afterDeleteValue (value) {
        // this.editedItem = Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
        if (Array.isArray(this.itemsProps)) {
          let index = this.itemsProps.findIndex((element, index, array) => {
            return element[this.item_value] === value[this.item_value]
          })
          this.itemsProps.splice(index, 1)
        }
        // atualiza o item dentro do pselect
        let item = this.$refs.PSelect.items.find((val) => { return val['id'] === value['id'] }) || {}
        // se o nome do status ou categoria tiver sido alterado muda o item pois no filtro de tarefas está salvando pelo id_text portanto se o usuário muda a descrição deve também mudar no campo da tarefa
        // if (this.entity === 'task_status' || this.entity === 'task_category') {
        if (this.multiple) {
          let itemsIds = JSON.parse(JSON.stringify(this.value))
          // exclui o registro deletado
          itemsIds.splice(itemsIds.indexOf(item[this.item_value]), 1)
          let items = []
          itemsIds.forEach(id => {
            items.push(this.$refs.PSelect.items.find(item => item[this.item_value] === id))
          })
          this.changeItem(itemsIds, items)
        } else {
          // Quando não é multiplo, so é permitido deletar o registro selecionado, portanto já deleta
          this.changeItem(null, {})
        }
        // recarrega as tarefas do usuário que excluir para que pelo menos no dele as tarefas estejam atualizadas
        this.$socket.emit('generalEvent', {
          data: {},
          notBroadcast: true,
          responseEvent: 'reloadTasksAll',
          room: `tasks${this.$auth.user().id}`
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PSelectModalEditable.vue